export default "/react/logoFair-690d594d.png";